import {
  CpaLoginV5SelectorShared,
  type CpaLoginV5SelectorSharedProps,
} from '@liscio/common';

export type CpaLoginV5SelectorProps = CpaLoginV5SelectorSharedProps;
export const CpaLoginV5Selector = CpaLoginV5SelectorShared;
export default CpaLoginV5SelectorShared;
